import React, { useRef, useEffect, useState } from 'react';
import { Row, Col, Button } from 'reactstrap';
import moment from 'moment/moment';
import { useReactToPrint } from 'react-to-print';
import { CSVLink } from 'react-csv';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileCsv } from '@fortawesome/free-solid-svg-icons';
//Components
import MainCard from '../../../components/MainCard/MainCard';
import CardRelatorio from '../components/CardRelatorio';

//Helpers
import mascaras from '../../../helpers/mascaras';

//Context
import { useAuth } from '../../../context/auth';

export default function RelatorioDemonstrativoDeColetasPorGerador({ dadosRelatorio, btnVoltar, filtros }) {
    const { session, setupVariavel } = useAuth();
    //Referencia do relatorio para download do csv
    const exportRef = useRef(null);
    //Botão de exportação csv
    const BtnExportCsv = () => {
        return (
            <Button className='mb-3' color='success' onClick={() => exportRef.current.link.click()}>
                <FontAwesomeIcon icon={faFileCsv} /> Gerar CSV
            </Button>
        )
    }
    //Referencia para a geração de pdf
    const refRelatorio = useRef();
  
    //Cabeçalhos para a listagem das coletas por meio do cardRelatorio
    const headersColetas = [
        { value: `Nº ${setupVariavel?.siglaDocumentoColeta}`, objectValue: "ordemColeta", col: "2" },
        { value: "SITUAÇÃO ORDEM COLETA", objectValue: "situacaoOrdemColeta", col: "5" },
        { value: "SITUAÇÃO DA COLETA", objectValue: "situacaoColeta", col: "5" },

        { value: "DATA/HORA EMISSÃO", objectValue: "dataHoraEmissao", col: "6" },
        { value: "DATA/HORA DA COLETA", objectValue: "dataHoraColeta", col: "6" },

        { value: "CIDADE DA COLETA", objectValue: "cidadeColeta", col: "4" },
        { value: "PLACA VEICULO", objectValue: "placa", col: "4" },
        { value: "SEQUENCIA", objectValue: "sequencia", col: "4" },

        { value: "DESCRIÇÃO DA ROTA COLETA", objectValue: "DescricaoRota", col: "12" },
        { value: "RECIPIENTE COLETADO", objectValue: "recipienteColetado", col: "12" },

        { value: "MODALIDADE DE COLETA", objectValue: "modalidadeColeta", col: "7" },
        { value: "IMPLEMENTO UTILIZADO", objectValue: "implemento", col: "5" },

        { value: "TIPO DE RESIDUO INFORMADO", objectValue: "tipoResiduoInformado", col: "8" },
        { value: "VOLUME COLETADO", objectValue: "volumeColetado", col: "4" },

        { value: "DESTINO DO RESÍDUO", objectValue: "destino", col: "6" },
        { value: "VOLUMETRIA", objectValue: "volumetria", col: "6" },
        { value: "PESO ESTIMADO DA COLETA", objectValue: "pesoEstimadoColeta", col: "12" },
        { value: "PESO TOTAL ENTRADA NO DESTINO", objectValue: "pesoTotalEntradaDestino", col: "6" },
        { value: "PESO TOTAL SAIDA DESTINO", objectValue: "pesoTotalSaidaDestino", col: "6" },
        { value: "CNPJ DO GERADOR", objectValue: "cnpjGerador", col: "5" },
        { value: "NOME DO GERADOR", objectValue: "gerador", col: "7" },
        { value: "ENDEREÇO", objectValue: "localColeta", col: "12" },
    ];
    //Headers para exportar csv
    const headersExport = headersColetas.map(value => {
        return { label: value.value, key: value.objectValue }
    })
    //Função assionada assim que o botão de imprimir pdf é clicado
    const handlePrint = useReactToPrint({
        content: () => refRelatorio.current,
        copyStyles: true,
        documentTitle: "Relatório demonstrativo de coletas por gerador",
    });

    return (
        <MainCard btnVoltarInTop={btnVoltar} btnImprimir={handlePrint} BtnAction1InTop={BtnExportCsv}>
            <CSVLink separator={";"} data={dadosRelatorio.listaColetas} headers={headersExport} filename="Relatorio demonstrativo de coletas por gerador.csv" target="_blank" ref={exportRef}></CSVLink>

            <div className="mt-4 relatorio w-100" ref={refRelatorio}>
                <div className="print m-2 d-flex align-items-center justify-content-between">
                    <p>Emitido por: {session.nome}</p>
                    <p>Data de emissão: {moment().format("DD/MM/YYYY HH:mm")}</p>
                </div>
                {setupVariavel?.logoTipo &&
                    <div className="d-flex align-items-center justify-content-center">
                        <img src={"data:image/png;base64," + setupVariavel?.logoTipo} style={{ maxWidth: '70%'}} />
                    </div>
                }
                <div className="header">
                    <h4 className='text-black'>Relatório demonstrativo de coletas por gerador</h4>
                    <Row>
                        <div className='col-4'>
                            <p><span className="fw-bold">Período:</span> {moment(filtros.dataInicial).format("DD/MM/YYYY")} à {moment(filtros.dataFinal).format("DD/MM/YYYY")}</p>
                        </div>
                    </Row>
                    <Row>
                        <div className='col-4'>
                            {filtros.geradorId_selected
                                ?
                                <p><span className="fw-bold">Gerador:</span> {filtros.geradorId_selected.label}</p>
                                :
                                <p><span className="fw-bold">Gerador:</span> Todos</p>
                            }
                        </div>
                    </Row>
                </div>
                <div className="body">
                    <h5 className='rounded-3 bg-secondary text-light p-2'>DADOS DO TRANSPORTADOR</h5>
                    <Row className='content-rel'>
                        <div className="col-6"><span className="fw-bold">Nome:</span> {dadosRelatorio.transportador.fantasia}</div>
                        <div className="col-6"><span className="fw-bold">CNPJ:</span> {mascaras.cnpjMask(dadosRelatorio.transportador.cnpj)}</div>
                        <div className="col-4"><span className="fw-bold">Responsável:</span> {dadosRelatorio.transportador.responsavel}</div>
                        <div className="col-4"><span className="fw-bold">E-mail:</span> {dadosRelatorio.transportador.email}</div>
                        <div className="col-4"><span className="fw-bold">Telefone:</span> {mascaras.celularMask(dadosRelatorio.transportador.fone)}</div>
                        <div className="col-4"><span className="fw-bold">CEP:</span> {mascaras.cepMask(dadosRelatorio.transportador.cep)}</div>
                        <div className="col-4"><span className="fw-bold">Cidade:</span> {dadosRelatorio.transportador.cidade}</div>
                        <div className="col-4"><span className="fw-bold">UF:</span> {dadosRelatorio.transportador.uf}</div>
                        <div className="col-4"><span className="fw-bold">Bairro:</span> {dadosRelatorio.transportador.bairro}</div>
                        <div className="col-4"><span className="fw-bold">Rua:</span> {dadosRelatorio.transportador.logradouro}</div>
                        <div className="col-4"><span className="fw-bold">Numero:</span> {dadosRelatorio.transportador.numero}</div>
                    </Row>
                    <h5 className='mt-4 rounded-3 bg-secondary text-light p-2'>COLETAS</h5>
                    <CardRelatorio headers={headersColetas} items={dadosRelatorio.listaColetas} />

                </div>
            </div>
        </MainCard>
    )
}